import * as React from "react";
import {Container, Drawer, Grid, Typography} from "@mui/material";
import {IndentSpace, Link1, Title5} from "../../../domains/common/components/Typography";
import {useEffect, useState} from "react";
import {ButtonBase} from "../../../domains/common/components/Button";
import {dealData} from "../deal";
import {getRREvents} from "../rrevents";

/**
 *
 * @param RealtyValues
 * @returns {Element}
 * @constructor
 */
export default function RREventsContainer({dealId}) {
  const [drawerState, setDrawerState] = useState(false);
  const [values, setValues] = useState(dealData.rrEvents)

  const getEvents = async () => {
    const result = await getRREvents(dealId) || [];
    setValues(result.data || []);
  }

  useEffect(() => {
  
  }, []);

  return (
    <div>
      <Drawer open={drawerState} anchor='right' ModalProps={{
        onBackdropClick: async () => {
          setDrawerState(false);
        }
      }}>
        <Container sx={{width: 600, padding: 1}}>
          <Grid container spacing={1} xs={12}>
            <Grid item xs={1}><Title5 title="События"/></Grid>
            {
              values?.map((item) => {
                return <RREventContainer event={item}></RREventContainer>
              })
            }
          </Grid>
        </Container>
      </Drawer>
      <ButtonBase variant="contained" size="small" onClick={() => {
        setDrawerState(true)
      }}>Этапы рассмотрения</ButtonBase>
    </div>
  )
}

export function RREventContainer({event}) {
  if (!event?.name || event?.name === 'void') {
    return;
  }

  let desc = '';

  if (event.name === 'accepted') {
    desc = <AcceptedEvent event={event}/>
  }

  if (event.name === 'quittance') {
    desc = <QuittanceEvent event={event}/>
  }


  if (event.name === 'processing') {
    desc = <ProcessingEvent event={event}/>
  }

  if (event.name === 'processingDone') {
    desc = <ProcessingDoneEvent event={event}/>
  }

  if (event.name === 'returned') {
    desc = <ReturnedDoneEvent event={event}/>
  }

  if (event.name === 'suspended') {
    desc = <SuspendedEvent event={event}/>
  }

  if (event.name === 'validationError') {
    desc = <ValidationError event={event}/>
  }

  return (
    <Grid container spacing={1} xs={12}>
      <Grid item xs={12} sx={{height: 20}}></Grid>
      <Grid item xs={12}>
        <Typography variant="body1" component="div" sx={{color: 'text.secondary'}} display="inline">
          {event.created}</Typography>
        <IndentSpace size={5}/>
        <Typography variant="body1" component="div" display="inline">
          {event.event.description}</Typography>
      </Grid>
      <Grid item xs={12}><Typography variant="body2" sx={{color: 'text.secondary', ml: 1.5}}>{desc}</Typography></Grid>
      <Grid item xs={12} sx={{height: 20, borderBottom: 1, borderColor: '#dadada'}}></Grid>
    </Grid>
  )
}

function ProcessingEvent({event}) {
  return `Дата исполнения ${event.event.executionDate}`
}

function ProcessingDoneEvent({event}) {
  const link = event.event?.link || event.event.originalLink ?
    <Link1 target="_blank" href={event.event?.link || event.event.originalLink}>Документы</Link1>
    : "- Документы отсутствуют"
  return (<span>Дата завершения {event.event.dateTime}(мск) {link}</span>)
}

function ReturnedDoneEvent({event}) {
  const link = event.event?.link || event.event.originalLink ?
    <Link1 target="_blank" href={event.event?.link || event.event.originalLink}>Документы</Link1>
    : "- Документы отсутствуют"
  return (<span>Дата завершения {event.event.dateTime}(мск) {link}</span>)
}

function SuspendedEvent({event}) {
  const link = event.event?.link || event.event.originalLink ?
    <Link1 target="_blank" href={event.event?.link || event.event.originalLink}>Документы</Link1>
    : "- Документы отсутствуют"
  return (<span>Дата завершения {event.event.dateTime}(мск) {link}</span>)
}

function AcceptedEvent({event}) {
  return `№ ${event.event.KUVDNumber} от ${event.event.KUVDDate}(мск)`
}

function QuittanceEvent({event}) {
  const sum = event.event.sum / 100
  return (<span>{`УИН ${event.event.UIA} Сумма ${sum} руб.`} <Link1 target="_blank" href={event.event?.link || event.event.originalLink}>Квитанция</Link1></span>)
}

function ValidationError({event}) {
  const error = event.event?.errors && event.event?.errors[0] || ''
  return (<span>{`Ошибка проверки ФЛК ${error}`}</span>);
}